module.exports = __webpack_public_path__ + "img/link.ab816f6b.svg";